
import { Helmet } from "react-helmet";

interface IndividualPageSEOProps {
  title: string;
  description: string;
  canonicalUrl: string;
}

export const IndividualPageSEO = ({
  title,
  description,
  canonicalUrl
}: IndividualPageSEOProps) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "TouristInformationCenter",
    "name": "NLocale - Découvrir l'Aisne comme un local",
    "description": description,
    "url": canonicalUrl,
    "areaServed": {
      "@type": "State",
      "name": "Aisne",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Hauts-de-France",
        "addressCountry": "FR"
      }
    },
    "keywords": "restaurants Aisne, hébergements Aisne, événements Aisne, tourisme local, expériences authentiques",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://onarrivebientot.nlocale.fr/particulier/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href={canonicalUrl} />
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};
